"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
const store_1 = require("../../../shared/store");
const gold_png_1 = __importDefault(require("../../assets/img/gold.png"));
const rainbow_png_1 = __importDefault(require("../../assets/img/rainbow.png"));
const pixi_js_1 = require("pixi.js");
const ColorfulBrushShader_1 = require("../shaders/ColorfulBrushShader");
const LaserBrushShader_1 = require("../shaders/LaserBrushShader");
const StarsBrushShader_1 = require("../shaders/StarsBrushShader");
const WatercolorBrushShader_1 = require("../shaders/WatercolorBrushShader");
const colors = {
    [store_1.StoreColors.Black]: 0x000000,
    [store_1.StoreColors.Red]: 0xff0000,
    [store_1.StoreColors.Blue]: 0x1400ff,
    [store_1.StoreColors.Green]: 0x00ff55,
    [store_1.StoreColors.Orange]: 0xff6b00,
    [store_1.StoreColors.Yellow]: 0xeeff00,
    [store_1.StoreColors.Purple]: 0xcc00ff,
    [store_1.StoreColors.Rainbow]: pixi_js_1.Texture.from(rainbow_png_1.default),
    [store_1.StoreColors.Gold]: pixi_js_1.Texture.from(gold_png_1.default),
    [store_1.StoreColors.Colorful]: ColorfulBrushShader_1.ColorfulBrushShader,
    [store_1.StoreColors.Laser]: LaserBrushShader_1.LaserBrushShader,
    [store_1.StoreColors.Stars]: StarsBrushShader_1.StarsBrushShader,
    [store_1.StoreColors.Watercolor]: WatercolorBrushShader_1.WatercolorBrushShader
};
exports.colors = colors;
